module.exports = __webpack_public_path__ + "img/Girl_010018.3f63173d.png";